/**
 * This class is responsible for enriching the onsite tracking data of elements with additional attributes.
 * It listens for the DOMContentLoaded event and initializes the enrichment process.
 * 
 * Handles dynamic calculation of data-element-position, enrichment of deferred third-party elements, etc.
 */
class OnsiteDataEnrichment {

  selectors = {
    sections: 'main>.shopify-section',
    trackedElements: '[data-onsite-tracking]'
  }
  
  constructor() {
    this.init();
  }

  init() {
    this.enrichElementPositions();
  }

  /**
   * Dynamically sets the data-element-position attribute for tracked elements
   * 
   * Schema: body-{sectionIndex}-{elementIndex}
   * Example: body-03-02 means the 2nd tracked element in the 3rd section of the page
   */
  enrichElementPositions() {
    const sections = document.querySelectorAll(this.selectors.sections);

    sections.forEach((section, sectionIndex) => {
      const trackedElements = Array.from(section.querySelectorAll(this.selectors.trackedElements));

      trackedElements.forEach((element, innerIndex) => {
        // skip setting the attribute if it was manually set by the editor
        if (element.dataset.elementPosition != undefined) {
          return;
        }

        const sectionIndexStr = (sectionIndex + 1).toString().padStart(2, '0');
        const innerIndexStr = (innerIndex + 1).toString().padStart(2, '0');

        element.setAttribute('data-element-position', `body-${sectionIndexStr}-${innerIndexStr}`);
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new OnsiteDataEnrichment();
});